import { TextAndIconButton } from 'src/components/atomsLegacy';
import styled from 'styled-components';

export const ButtonContainer = styled.div<{ mobile?: boolean }>`
  display: flex;
  justify-content: flex-end;
  column-gap: 8px;
`;

export const DeleteButton = styled(TextAndIconButton)`
  background-color: white;
  color: ${(props) => props.theme.newPalette.turquoise.T300};
  padding: 7px 16px;
  gap: 8px;
  border: solid 1px ${(props) => props.theme.newPalette.turquoise.T300};
`;

export const SubmitButton = styled(TextAndIconButton)`
  background-color: ${(props) => props.theme.newPalette.turquoise.T300};
  color: ${(props) => props.theme.newPalette.neutral.N0};
  padding: 7px 16px;
  gap: 8px;
`;

export const EvidenceContainer = styled.div`
  h5 {
    margin-top: 10px;
  }
  div {
    margin-top: 4px;
  }
`;
